import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  pos: [],
  posById: {},
  cart: [],
  cartById: {}
}

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToPos: (state, action) => {
      state.pos.push(action.payload)
      state.posById[action.payload.slug] = 1
    },
    handlePosDecrement: (state, action) => {
      const slug = action.payload

      if (state.posById[slug] === 1) {
        state.pos = state.pos.filter(p => p.slug !== slug)
        delete state.posById[slug]
      } else {
        state.posById[slug] -= 1
      }
    },
    handlePosIncrement: (state, action) => {
      const slug = action.payload
      state.posById[slug] += 1
    },
    emptyPos: (state) => {
      state.pos = []
      state.posById = {}
    },
    swapDealProduct: (state, action) => {
      const deal = state.pos[action.payload.itemIndex]
      deal.deal_products[action.payload.productIndex] = action.payload.dealProduct
      state.pos[action.payload.itemIndex] = deal
    },
    removeSwapDealProduct: (state, action) => {
      const deal = state.pos[action.payload.itemIndex]
      deal.deal_products[action.payload.productIndex] = deal.deal_products[action.payload.productIndex].original_product
      state.pos[action.payload.itemIndex] = deal
    },
    addToCart: (state, action) => {
      state.cart.push(action.payload)
      state.cartById[action.payload.slug] = 1
    },
    handleCartDecrement: (state, action) => {
      const slug = action.payload

      if (state.cartById[slug] === 1) {
        state.cart = state.cart.filter(p => p.slug !== slug)
        delete state.cartById[slug]
      } else {
        state.cartById[slug] -= 1
      }
    },
    handleCartIncrement: (state, action) => {
      const slug = action.payload
      state.cartById[slug] += 1
    },
    emptyCart: (state) => {
      state.cart = []
      state.cartById = {}
    },
  },
})

export const {
  addToPos, handlePosDecrement, handlePosIncrement, emptyPos, swapDealProduct, removeSwapDealProduct,
  addToCart, handleCartDecrement, handleCartIncrement, emptyCart
} = cartSlice.actions
export default cartSlice.reducer